<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayFailure">
        <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
    </div>
    <div class="row mb-5 empContainer">
        <div style="width:360px">
            <img empImage style="width:360px" src={{rep[0].EmployeePhoto}} alt="emp image">
        </div>
        <div style="width:500px; margin-left:40px">
            <h5 class="DIN2014Regular"
                style="text-transform:capitalize; font-size:25px; font-weight:700;letter-spacing: .5px; padding-top:10px">
                {{rep[0].FirstName}} {{rep[0].LastName}}</h5>
            <h5 class="DIN2014Regular"
                style="text-decoration-line: underline; font-size:20px; line-height: 30px; font-weight:700; letter-spacing: .4px">
                {{rep[0].email | lowercase }}</h5>
            <h5 class="DIN2014Regular"
                style="text-transform:uppercase; font-size:20px; line-height: 30px; font-weight:700; letter-spacing: .4px">
                <a href='tel:{{rep[0].phone}}'style="color:black">{{rep[0].phone | phoneNumber }}</a></h5>
            <h5 class="DIN2014Regular"
                style="text-transform:capitalize; font-size:20px; line-height: 30px; letter-spacing: .4px; font-weight:400;">
                {{rep[0].Market}}</h5>
            <h3 class="col" style="display:inline;"><a class="DINNextLTPro-Black lightBlueBackground blueText"
                    style="font-size:20px;padding:8px; text-decoration: none !important"
                    href='mailto:{{rep[0].email}}?subject=Let&#39;s Connect'>LET'S CONNECT</a></h3>
        </div>
    </div>
    <div class="mb-5" *ngIf="this.dotComService.resourceFilteredPosts.length>0"
        style="width:90%; margin:auto; max-width: 1500px;">
        <!-- table of posts based on no filter ar filter applied  -->
        <h2 class="Caecilia76BoldItalic mt-3 mb-3 greenText" style="font-size:28px; font-weight: 700;">Resources By
            {{rep[0].FirstName}} {{rep[0].LastName}}
        </h2>
        <div *ngFor="let row of this.dotComService.resourceFilteredPosts" style="text-align: left">
            <div class="row mt-0">
                <div class="repsResourceContainer">
                    <img class="repsResourceImage" src={{row.ImageName}} alt="post image">
                </div>
                <div class="repsResourceTextContainer">
                    <h3 class="DIN2014Bold" style="font-size:19px; line-height:23px; letter-spacing: .38px;">
                        {{this.dotComService.HtmlStringToPlainText( row.Title)}}</h3>
                    <h4 class="DIN2014Regular" style="font-size:14px; line-height: 19.2px;margin-bottom:15px">
                        {{row.RevisionAuthor}}
                    </h4>
                    <h5 class="DIN2014Regular greenText"
                        style="cursor:pointer; font-size:16px; line-height: 19px; font-weight:600; text-decoration-line: underline;"
                        (click)="GoToBlog(row)">
                        READ ARTICLE ></h5>
                </div>
            </div>
        </div>
    </div>



<!--     
    <div class="row pt-3 pb-3" style="background-size: cover; background-position:center; padding-bottom:5%"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">
        <div class="row pt-3" style="width:80%; max-width:1500px; margin:auto;">
            <div class="col-md-6 mt-5" style="border-right:solid 1px white">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="margin-left:20%;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                    Search By Zip Code</h2>
            </div>
            <div class="col-md-6 mt-5">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="margin-left:20%;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                    Search By Current Location</h2>
            </div>
        </div>
        <div class="row" style="width:80%; max-width:1500px; margin:auto;">
            <div class="col-md-12 text-center">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="font-size: 21px;font-style: normal;font-weight: 700;line-height: 21px;">
                    or</h2>
            </div>
        </div>
        <div class="row" style="width:80%; max-width:1500px; margin:auto;">
            <div class="col-md-6 mb-5" style="border-right:solid 1px white">
                <div class="row d-block">
                    <input Class="DIN2014Regular"
                        style="margin-left:20%;display:inline;font-size:19px;line-height:30px;height:48px;width:254px"
                        placeholder="Zip Code" [(ngModel)]="this.zipCode">
                    <a class="col-lg-4"
                        style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                        (click)="GetRepsFromZip()">
                        <h3 class=" DIN2014Regular whiteText blueBackground"
                            style="display:inline;text-align: left;padding:10px;font-size:20px;font-weight: 700;">SUBMIT
                        </h3>
                    </a>
                </div>
            </div>
            <div class="col-md-6 mb-5">
                <a class="col-lg-4"
                    style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="GetRepsFromCurrentLocation()">
                    <h3 class=" DIN2014Regular whiteText blueBackground"
                        style="margin-left:20%;display:inline;text-align:left;padding:10px;font-size:20px;font-weight: 700;">
                        USE MY LOCATION
                    </h3>
                </a>
            </div>
        </div>
    </div> -->







    <div class="pt-3" style="padding-bottom:70px;background-size: cover; background-position:center;" [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">

<!-- desktop  -->
<div class="pt-3" style="padding-bottom:70px"
    *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">

    <div class="row " style="padding-top:70px;width:1200px;; max-width:1200px; margin:auto;">
        <div class="col-md-6" style="border-right:solid 1px grey">
            <h2 class="Caecilia76BoldItalic"
                style="margin-left:88px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Zip Code</h2>
        </div>
        <div class="col-md-6">
            <h2 class="Caecilia76BoldItalic"
                style="margin-left:122px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Current Location</h2>
        </div>
    </div>
    <div class="row" style="width:1200px; max-width:1200px; margin:auto;">
        <div class="col-md-12 text-center">
            <h2 class="Caecilia76BoldItalic"
                style="font-size: 21px;font-style: normal;font-weight: 700;line-height: 21px;">
                or</h2>
        </div>
    </div>
    <div class="row" style="width:1200px;; max-width:1200px; margin:auto;">
        <div class="col-md-6" style="border-right:solid 1px grey">
            <div class="row d-block">
                <input Class="DIN2014Regular"
                    style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px; margin-left:100px"
                    placeholder="Zip Code" [(ngModel)]="this.zipCode">
                <a class="col-lg-4"
                    style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="GetRepsFromZip()">
                    <h3 class="DINNextLTPro-Black whiteText blueBackground"
                        style="display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">SUBMIT</h3>
                </a>
            </div>
        </div>
        <div class="col-md-6">
            <a class="col-lg-4"
                style="margin-top:20px;padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                (click)="GetRepsFromCurrentLocation()">
                <h3 class="DINNextLTPro-Black whiteText blueBackground"
                    style="position:relative; top:5px;margin-left:20%;display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">
                    USE MY LOCATION
                </h3>
            </a>
        </div>
    </div>
</div>

<!-- mobile -->
<div class="container"
    *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && (myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
    <div class="row text-center" style="margin-top:50px">
        <div class="col-12">
            <h2 class="Caecilia76BoldItalic whiteText"
                style="font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Zip Code</h2>
        </div>

    </div>
    <div class="row text-center">
        <div class="col-12">
            <input Class="DIN2014Regular" style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px"
                placeholder="Zip Code" [(ngModel)]="this.zipCode">
        </div>
    </div>
    <div class="row text-center">
        <div class="col-xs-12" style="text-align: center;margin-top:20px">
            <button class="DINNextLTPro-Black whiteText blueBackground"
                style="border:none; padding: 12px 12px 3px 12px; margin: auto; display: block;" (click)="GetRepsFromZip()">
                <h3 style="font-size:20px;font-weight:900;">SUBMIT</h3>
            </button>
        </div>
    </div>

    <div class="row text-center" style="margin-top:50px">
        <div class="col-12">
            <h2 class="Caecilia76BoldItalic whiteText"
                style="font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Current Location</h2>
        </div>

    </div>
    <div class="row text-center">
        <div class="col-xs-12" style="text-align: center;">
            <button class="DINNextLTPro-Black whiteText blueBackground"
                style="border:none; padding: 12px 12px 3px 12px; margin: auto; display: block;" (click)="GetRepsFromCurrentLocation()">
                <h3 style="font-size:20px;font-weight:900;">USE MY LOCATION</h3>
            </button>
        </div>
    </div>
</div>        

        <!-- <div class="row " style="padding-top:70px;width:1200px;; max-width:1200px; margin:auto;">
            <div class="col-md-6" style="border-right:solid 1px white">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="margin-left:88px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                    Search By Zip Code</h2>
            </div>
            <div class="col-md-6">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="margin-left:122px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                    Search By Current Location</h2>
            </div>
        </div>
        <div class="row" style="width:1200px; max-width:1200px; margin:auto;">
            <div class="col-md-12 text-center">
                <h2 class="Caecilia76BoldItalic whiteText"
                    style="font-size: 21px;font-style: normal;font-weight: 700;line-height: 21px;">
                    or</h2>
            </div>
        </div>
        <div class="row" style="width:1200px;; max-width:1200px; margin:auto;">
            <div class="col-md-6" style="border-right:solid 1px white">
                <div class="row d-block">
                    <input Class="DIN2014Regular"
                        style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px; margin-left:100px"
                        placeholder="Zip Code" [(ngModel)]="this.zipCode">
                    <a class="col-lg-4"
                        style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                        (click)="GetRepsFromZip()">
                        <h3 class="DINNextLTPro-Black whiteText blueBackground"
                            style="display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">SUBMIT</h3>
                    </a>
                </div>
            </div>
            <div class="col-md-6">
                <a class="col-lg-4"
                    style="margin-top:20px;padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="GetRepsFromCurrentLocation()">
                    <h3 class="DINNextLTPro-Black whiteText blueBackground"
                        style="position:relative; top:5px;margin-left:20%;display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">
                        USE MY LOCATION
                    </h3>
                </a>
            </div>
        </div> -->
    </div>












    <div>
        <div class="row yourPartnerForSuccess" id="partnersSuccessBlock">
            <div class="col-lg-4 greenText" style="padding-right:0px; padding-left:0px">
                <h3 class="Caecilia76BoldItalic yourPartnerForSuccessDetail">
                    Harrell's Is Your<br />Partner For Success</h3>
            </div>
            <div class="col-lg-8">
                <div class="row" style="padding-right:10%;">
                    <div class="col-lg-4 blueText text-center yourPartnerForSuccessBorder">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-1.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                PH.D'S INNOVATING
                                <br>
                                PRODUCTS AND
                                <br>
                                PROGRAMS
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-4.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-2.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-5.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-3.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                IT PROVIDING <BR> PROPRIETARY <BR> TECH
                            </h4>
                        </div>
                        <div class="margin:10px;">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.marketsImagePaths + 'icon-6.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- <div class="row pt-3">
        <div class="col-lg-4 greenText" style="padding-right:0px; padding-left:0px; padding-top:5%">
            <h3 class="Caecilia76BoldItalic"
                style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
                Harrell's Is Your<br />Partner For Success</h3>
        </div>
        <div class="col-lg-8">
            <div class="row" style="padding-right:10%;">
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div style="border-left:solid 1px grey">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-1.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            PH.D'S INNOVATING
                            <br>
                            PRODUCTS AND
                            <br>
                            PROGRAMS
                        </h4>
                    </div>
                    <div style="border-left:solid 1px grey">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-4.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                        </h4>
                    </div>
                </div>
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-2.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-5.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                        </h4>
                    </div>
                </div>
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-3.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            IT PROVIDING <BR> PROPRIETARY <BR> TECH
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.marketsImagePaths + 'icon-6.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>